import fixedHeader from '../modules/fixedBlock';
import vars from '../helpers';
const $arrowBtnDesktop = vars.$document.find('.header__arrow-btn-desktop--js');
const $arrowBtnMobile = vars.$document.find('.header__arrow-btn-mobile--js');
import scroller from './scroller';

function init() {
	fixedHeader.init();
}

function destroy() {
	fixedHeader.destroy();
}

function arrowClickHandlerDesktop() {
	const $mainContent = vars.$document.find('#mainContent');
	const scrollbar = scroller.init();
	const y = $mainContent.offset().top + scrollbar.offset.y;
	scrollbar.scrollTo(0, y, 1000);
}

function arrowClickHandlerMobile() {
	const $mainContent = vars.$document.find('#mainContent');
	const $headerLogos = vars.$document.find('.header__logos');
	const offset = $headerLogos.css('position') === 'fixed' || $headerLogos.css('position') === 'absolute' ? -$headerLogos.outerHeight(true) : 0;
	vars.scrollTo($mainContent, 500, offset + 1);
}

function scrollToMainInit() {
	vars.isScreen.isMobile(() => {
		$arrowBtnMobile.on('click.srl_main', arrowClickHandlerMobile);
	}, () => {
		$arrowBtnMobile.off('click.srl_main', arrowClickHandlerMobile);
	});

	vars.isScreen.isDesktop(() => {
		$arrowBtnDesktop.on('click.srl_main', arrowClickHandlerDesktop);
	}, () => {
		$arrowBtnDesktop.off('click.srl_main', arrowClickHandlerDesktop);
	});
}

function scrollToMainDestroy() {
	$arrowBtnDesktop.off('.srl_main');
	$arrowBtnMobile.off('.srl_main');
}

export default {
	init,
	destroy,
	scrollToMainInit,
	scrollToMainDestroy,
};
